<template>
    <input-group
        v-model="internalValue"
        :schema="props.schema"
    >
        <template #label>
            <slot name="label" />
        </template>

        <template #input>
            <flex-container v-if="loading">
                <spinner-loader variant="inline" />
            </flex-container>
            <slot v-else name="input" />
        </template>
    </input-group>
</template>

<script setup lang="ts">
    import { FlexContainer, InputGroup, SpinnerLoader } from '@keyvue/one-ui';
    import { computed, ref, watch } from 'vue';

    interface Props {
        modelValue: any[];
        items: any[];
        schema: any;
        valueKeyName?: string;
        loading?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        valueKeyName: 'value',
        loading: false,
    });

    const emit = defineEmits<{
        (e: 'update:modelValue', value: any[]): void;
    }>();

    const internalValue = ref<any[]>([]);

    const syncInternalValue = () => {
        internalValue.value = props.items.filter((item) => {
            return props.modelValue.includes(item[props.valueKeyName]);
        });
    };

    const selectedScalarValues = computed(() => {
        return internalValue.value.map((item) => item[props.valueKeyName]);
    });

    watch(() => internalValue.value, () => {
        // eslint-disable-next-line eqeqeq
        if (props.modelValue == selectedScalarValues.value) {
            return;
        }

        emit('update:modelValue', selectedScalarValues.value);
    }, { deep: true });

    watch(props.modelValue, () => {
        internalValue.value = props.items.filter((item) => {
            return props.modelValue.includes(item[props.valueKeyName]);
        });
    }, { deep: true });

    watch(() => props.loading, () => {
        if (!props.loading) {
            syncInternalValue();
        }
    }, { immediate: true });
</script>
